/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import logo from "../../assets/images/Idntfy-logo.svg";

function IdntfyHeader() {
  return (
    <header className='bg-brand w-full flex items-center justify-center text-white p-4  mx-auto'>
    <img src={logo} alt="idntfy" className='w-[87px]' />
    </header>
  )
}

export default IdntfyHeader